import React from 'react';
import { BookOpenIcon, ClipboardListIcon, ImageIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const items = [{
  icon: BookOpenIcon,
  label: 'PDF 1',
  title: 'La Biblia del Método Pro-Pádel 360',
  desc: '(6 Tomos de puro sistema). El método completo en PDF: cómo estructurar tus clases, progresar a cada alumno y ordenar tu año sin improvisar.'
}, {
  icon: ClipboardListIcon,
  label: 'PDF 2',
  title: 'Arsenal de +100 Ejercicios de Élite',
  desc: '(Tu clase resuelta en 30 segundos). El banco de ejercicios aplicados al método, organizados por objetivo y nivel. Abrís el PDF y tenés la clase resuelta.'
}, {
  icon: ImageIcon,
  label: 'IMÁGENES',
  title: 'Guía Visual de Corrección en Pista',
  desc: '(Para que el alumno diga: "Este tipo sabe de lo que habla"). Cada golpe explicado visualmente para corregir técnica en pista y para compartir con tus alumnos.'
}];
export function PilatesContents() {
  return <section className="bg-padel-surface px-4 py-16 sm:py-24" data-id="element-140" data-mp="3qktqkqmrf48f">
      <div className="mx-auto max-w-5xl" data-id="element-141" data-mp="3qkk3bat3nb6f">
        <FadeIn data-id="element-142" data-mp="3vjocw2jxraxa">
          <div className="mx-auto max-w-2xl text-center" data-id="element-143" data-mp="3vj52r80j1qtt">
            <p className="font-bold tracking-widest text-padel-lime" data-id="element-144" data-mp="3vlrb39v8sad3">
              🏆 STOCK DIGITAL™ MÉTODO PRO-PÁDEL
            </p>
            <h2 className="mt-3 font-display text-4xl font-black text-white sm:text-5xl" data-id="element-145" data-mp="8fgsd9ggc4y3">
              Qué te llevás hoy
            </h2>
            <p className="mt-3 text-gray-300" data-id="element-146" data-mp="37w6q6lfj3316">
              Tres recursos de poder listos para usar desde el primer día.
            </p>
          </div>
        </FadeIn>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-147" data-mp="3gtz4pndfe6ni">
          {items.map(({
          icon: Icon,
          label,
          title,
          desc
        }, i) => <FadeIn key={title} delay={i * 0.08} data-id="element-148" data-mp="3ln1pb60865rk" data-mpi={i}>
              <article className="flex h-full flex-col rounded-2xl border border-padel-muted bg-padel-dark p-6" data-id="element-149" data-mp="2o6wc1bvfkq56">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-padel-muted bg-padel-surface text-padel-lime" data-id="element-150" data-mp="2t4o4q83wggaf">
                  <Icon className="h-6 w-6" data-id="element-151" data-mp="8uy39l7prs4" />
                </span>
                <span className="mt-5 text-xs font-bold uppercase tracking-[0.16em] text-padel-lime" data-id="element-152" data-mp="3rgh2j4fr9ya1">
                  {label}
                </span>
                <h3 className="mt-2 font-display text-xl font-bold text-white" data-id="element-153" data-mp="51xrnhpzp18b">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-400" data-id="element-154" data-mp="3dgpnd0di6bug">
                  {desc}
                </p>
              </article>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.28} data-id="element-155" data-mp="3mip5jw097lyz">
          <div className="mt-10 rounded-2xl border border-padel-lime/30 bg-padel-dark p-6" data-id="element-156" data-mp="3mjqqqtazhouf">
            <div className="grid gap-3 sm:grid-cols-2" data-id="element-157" data-mp="3hib6h3gmrmd3">
              {['Acceso digital inmediato', 'Para nivel Inicial, Intermedio y Avanzado', 'Lo abrís desde el celular, tablet o computadora', 'Diseñado para el profe argentino'].map(x => <p key={x} className="text-sm text-gray-300" data-id="element-158" data-mp="15bysxw8j32ew">
                  ✅ {x}
                </p>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}